import { useMutation, useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { apiClient } from '@/lib/apiClient'

import type { FeedbackAnswer, FeedbackForm } from './types'

function path(edition: string | null): string {
  return edition ? `/public/feedback?edition=${encodeURIComponent(edition)}` : '/public/feedback'
}

/**
 * Le formulaire d'avis : textes de l'édition dans la langue choisie, ouvert ou
 * fermé, et le jeton qui date son affichage. Relu au changement de langue —
 * les textes suivent — sans que le formulaire en cours ne soit remis à zéro.
 */
export function useFeedbackForm(edition: string | null) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['public-feedback', edition, i18n.language],
    queryFn: () => apiClient.get<FeedbackForm>(path(edition), { locale: i18n.language }),
    retry: 1,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  })
}

export function useSubmitFeedback(edition: string | null) {
  return useMutation({
    mutationFn: (answer: FeedbackAnswer) =>
      apiClient.post<{ ok: boolean }>(path(edition), answer),
  })
}
